import { Trans, useLingui } from '@lingui/react/macro';

import { InputCountry } from '@/components/InputCountry/InputCountry';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useUpdateArticle } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

export const PurchaseCountry = () => {
  const { t } = useLingui();

  const { request, article, view, errors } = useArticleContext();

  const { mutate: updateArticle } = useUpdateArticle({
    articleId: article.id,
    requestId: request.id,
  });

  return (
    <InputCountry
      label={
        <>
          <Trans id="article.form.purchase-country.label">Purchase country</Trans>
          {!view.warranty.fields.purchaseCountry.required && <OptionalLabel />}
        </>
      }
      value={article.purchaseCountry}
      onChange={(newPurchaseCountry) => {
        updateArticle({
          data: {
            purchaseCountry: newPurchaseCountry,
          },
        });
      }}
      error={
        errors.warranty?.missingPurchaseCountry
          ? t({
              id: 'article.form.purchase-country.error.missing',
              message: 'A purchase country is required',
            })
          : undefined
      }
    />
  );
};
